// Saved bookmarks don't record which database they came from, so EBSCO and
// ProQuest items are recognised by their result URL host.
const DATABASE_HOSTS = ["search.ebscohost.com", "proquest.com"];

export const isDatabaseSourceUrl = (url) => {
  try {
    const hostname = new URL(url).hostname.toLowerCase();
    return DATABASE_HOSTS.some(
      (host) => hostname === host || hostname.endsWith(`.${host}`)
    );
  } catch {
    return false;
  }
};
